<template>


  <div class="card-a border p-3 shadow-sm" >

    <div class="image-box ">
      <img class=" " :src="image" :alt="alt">
    </div>

    <slot>
      <div class="card-body ">

        <a class="card-text font-size-dynamic-h5 font-weight-bold text-dark" href="">
          انجیر 2AS نرم و شیرین (10کیلویی) با ارسال رایگان ایلیاتین</a>

      </div>
      <div>
        <span><i class="bi bi-star-fill text-warning star"></i></span>
        <span class="font-weight-bold px-2">4.5</span>
        <span class="font-size-dynamic-h6 custom-text-color">(10 نظر)</span>
      </div>

      <div class="text-left">
        <span class=" font-weight-bold ">قیمت:</span>
        <span class="px-2 font-weight-bold"> 175,000  </span>
        <small class="text-center float-left price-font ">
          هــــزار
          <br>
          تـــومان
        </small>
      </div>
      <div class="text-left">
        <span class="custom-text-color  font-size-dynamic-h6">کیلویی:</span>
        <span class="custom-text-color px-2 font-weight-bold font-size-dynamic-h6">190,000</span>
        <small class="text-center float-left price">
          هــــزار
          <br>
          تـــومان
        </small>

      </div>
      <div class="text-center shadow-sm  ">
        <div class="btn btn-primary col-12 my-2">
          خرید
        </div>

      </div>
    </slot>
  </div>


</template>


<script>
import mA from "../Tags/A.vue";
import mImg from "../Tags/Img.vue";
import {CardProps} from "./CardProps";

export default {
  name: "Card516",
  components: {mA, mImg},
  props: {
    ...CardProps,
  }
}
</script>


<style scoped>
.image-box {
  width: 100%; /* عرض ثابت برای همه divها */
  height: 200px; /* ارتفاع ثابت برای همه divها */
  overflow: hidden;
  position: relative;
  border-radius: 8px;
}

.image-box img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* تغییر سایز بدون از دست دادن تناسب */
  object-position: center; /* مرکزیت تصویر */
}

.card-a {
  height: 470px;

}


.star {
  font-size: 12px;

}

.price-font {
  font-size: 9px;
  margin-top: 2px;

}

.custom-text-color {
  color: rgb(129, 129, 129);
}


.price {
  font-size: 9px;
  margin-top: 2px;
}

.font-size-dynamic-h6 {
  font-size: calc(0.7rem + 0.2vw);
}

.font-size-dynamic-h5 {
  font-size: calc(0.9rem + 0.1vw);
}


</style>
